import React from 'react';
import styles from './LeftBar.module.scss';

const LeftBar = ({ title, links }) => {
    return (
        <div className={styles.left_bar}>
            <div className={styles.left_bar_title}>{title}</div>
            <div style={{ width: '80%', backgroundColor: '#000', height: '1px' }}></div>
            <ul className={styles.left_bar_content}>
                {links.map((link, index) => (
                    <li key={index} className={link.showMore ? styles.more : ""}>
                        <a href={link.url} target="_self" className={link.showMore ? styles.moreLink : ""}>
                            {link.label}
                        </a>
                    </li>

                ))}
            </ul>
        </div>
    );
}

export default LeftBar;
